import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Template } from '../../pages/runtime-typechecker';

export type SchemaInformationTypes = {
  distance?: number;
  duration?: number;
  source?: string;
  destination?: string;
  earliestBus?: string;
  lastBus?: string;
  busNames?: Array<string>;
  minPrice?: string;
  maxPrice?: string;
  averageRating?: number;
  ratingCount?: number;
};

type SchemaInformationProps = {
  schemaInformation: SchemaInformationTypes;
  templateData: Template;
};

export default function SchemaInformation({
  schemaInformation,
  templateData
}: SchemaInformationProps) {
  const productSchemaData = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: templateData.metaTitle,
    description: templateData.metaDescription,
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: schemaInformation.averageRating
        ? schemaInformation.averageRating
        : 4.6,
      reviewCount: schemaInformation.ratingCount
        ? schemaInformation.ratingCount
        : 45000
    },
    brand: {
      '@type': 'Service',
      name: 'MakeMyTrip'
    },
    offers: {
      '@type': 'Offer',
      price: schemaInformation.minPrice,
      priceCurrency: 'INR',
      url: templateData.sampleUrl
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(productSchemaData)}
      </script>
    </Helmet>
  );
}
